import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';

export enum GridAction {
	Delete = 'delete',
}

export interface IGridActionModalData {
	gridId: number | Array<number>;
	element: string;
	action: GridAction;
}

@Component({
	selector: 'app-grid-action-popup',
	templateUrl: './grid-action-popup.component.html',
	styleUrls: ['./grid-action-popup.component.scss'],
})
export class GridActionPopupComponent<T extends IGridActionModalData>
	extends DcBaseComponent
	implements OnInit
{
	public vo$!: Observable<{
		element: string;
		gridId: number | Array<number>;
		isMultipleElement: boolean;
		action: GridAction;
	}>;
	public confirmDeletion = false;

	protected readonly DcIcons = DcIcons;
	protected readonly GridAction = GridAction;
	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'grid-action';
	}

	public ngOnInit(): void {
		super.ngOnInit();
		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.gridId) && this.modalData.element === '',
			gridId: this.modalData.gridId,
			action: this.modalData.action,
		});
	}

	public confirmAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
